export default function Hero() {
  const scrollToVPN = () => {
    const element = document.getElementById('vpn');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-gray-50 via-white to-teal-50">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="absolute top-20 left-10 w-72 h-72 bg-teal-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-200/20 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <h1 className="text-6xl md:text-7xl font-bold text-gray-900 leading-tight">
              Secure Your Digital Freedom
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Experience ultimate online privacy and security with HORAL VPN. Browse anonymously, access content freely, and protect your data with military-grade encryption.
            </p>
            <button
              onClick={scrollToVPN}
              className="group bg-gradient-to-r from-teal-500 to-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all duration-300 inline-flex items-center space-x-2 whitespace-nowrap cursor-pointer"
            >
              <span>Get Started Now</span>
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>

          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://public.readdy.ai/ai/img_res/b638ef02763ea98daf30ef4b0f3482c4.jpg"
                alt="VPN Security Illustration"
                className="w-full h-auto drop-shadow-2xl"
              />
            </div>
            
            <div className="absolute top-10 -right-10 w-32 h-32 bg-gradient-to-br from-teal-400 to-teal-600 rounded-2xl opacity-20 animate-pulse"></div>
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-gradient-to-br from-purple-400 to-purple-600 rounded-full opacity-20 animate-pulse delay-75"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
